import { useMemo } from 'react';
import _ from 'lodash';
import { useApi } from './api';

export const useTeam = (abbrv) => useApi(`team?id=${abbrv}`);

export const useTeams = () => {
  const [data, loading, error] = useApi('league/teams');

  const sortedTeams = useMemo(() => _.sortBy(data, 'name', 'desc'), [data]);

  return [sortedTeams, loading, error];
};

export const useTeamLogos = () => useApi('team-logos');

export const useTeamLogo = (abbrv) => {
  const [teams, loading, error] = useTeamLogos();

  const team = useMemo(
    () => teams?.find((x) => x.abbrv === abbrv),
    [teams, abbrv]
  );
  const logo = team?.logo || team?.logoImageUrl;

  return [logo, loading, error];
};

export const useTeamStaff = (abbrv) => useApi(`team/staff?id=${abbrv}`);
